var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleMeet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.52662 6.66943H0V15.3063H5.52662V6.66943Z",
    fill: "#4178BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52662 15.3062H0V19.5442C0.0489768 19.9781 0.251229 20.3786 0.568539 20.6699C0.88585 20.9613 1.29624 21.1234 1.72217 21.1256H5.52662V15.3062Z",
    fill: "#2863AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52667 15.3065V21.126H17.3282C17.7872 21.1234 18.2266 20.9352 18.551 20.6023C18.8755 20.2694 19.0587 19.8187 19.061 19.348V15.7304L13.5528 10.9851V15.3065H5.52667Z",
    fill: "#00AA4C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5498 10.9858L19.058 15.7302V6.3894L13.5498 10.9858Z",
    fill: "#008041"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.058 6.38927V15.73L22.5334 18.7241C23.0319 19.153 24 19.0418 24 18.2278V3.96796C24.0012 3.81273 23.9587 3.66045 23.8774 3.52944C23.7962 3.39844 23.6798 3.2943 23.5422 3.22958C23.4047 3.16485 23.2518 3.14229 23.102 3.16462C22.9522 3.18695 22.8119 3.25322 22.6979 3.35544L19.058 6.38927Z",
    fill: "#00AA4C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5528 10.9849L19.061 6.38948V2.64881C19.0587 2.19268 18.8863 1.75474 18.5793 1.42472C18.2722 1.0947 17.8537 0.897593 17.4095 0.873779H5.52667V6.66943H13.5528V10.9849Z",
    fill: "#FDB813"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52662 6.66943V0.873779H5.51113L0 6.65851V6.66943H5.52662Z",
    fill: "#E93525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMeet);
export default __webpack_public_path__ + "static/media/googleMeet.cf1f82e8f1b7430359c8938823a2eb98.svg";
export { ForwardRef as ReactComponent };